import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { aceiteInterface } from '../../interfaces/curso/termo-aceite-response.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfirmaTermoFluxoContinuoService {

  _http = inject(HttpClient)

  confirmarTermoFluxoContinuo(sigla: string, ofer: string, pf_rg: string, aceito: boolean): Observable<aceiteInterface> {

    //http://localhost/api/fluxoContinuo/EDU-0290/003/427726cxxc62-1

    let data = {
      sigla: sigla,
      ofer: ofer,
      pf_rg: pf_rg,
      aceite: aceito
    }

    return this._http.post<aceiteInterface>( environment.url + `/api/fluxoContinuo`, data);
  }

}
